import React from 'react';
import { Link } from 'react-router-dom';

const Quote = ({ quote, onDelete }) => {
  return (
    <tr>
      <td>{quote.text}</td>
      <td>{quote.author}</td>
      <td>{quote.language}</td>
      <td>{quote.category}</td>
      <td>
        <Link to={`/dashboard/quotes/${quote._id}`} className="btn btn-sm btn-warning">Edit</Link>
        <button onClick={() => onDelete(quote._id)} className="btn btn-sm btn-danger">Delete</button>
      </td>
    </tr>
  );
};

export default Quote;